import { backendClient } from "@/api/backendClient";

import type {
  CaseTemplateExtended,
  CaseTemplateListQueryParams,
  CaseTemplateToPublicPortal,
} from "@waku-care/types/contracts/internal";

import type { CaseTemplateLink } from "@/api/resources/publicPortals/api";
import type { InsertCaseTemplate, UpdateCaseTemplate } from "@/supabase.types";

export const getCaseTemplateById = async (id: string) => {
  const { data, error } = await backendClient.get<CaseTemplateExtended>(`/case-templates/${id}`);
  if (error) throw error;
  return data;
};

export const createCaseTemplate = async ({ values }: { values: InsertCaseTemplate }) => {
  const { data, error } = await backendClient.post<CaseTemplateExtended>(`/case-templates`, {
    body: values,
  });
  if (error) throw error;
  return data;
};

export const updateCaseTemplateById = async ({ id, values }: { id: string; values: UpdateCaseTemplate }) => {
  const { data, error } = await backendClient.patch<CaseTemplateExtended>(`/case-templates/${id}`, {
    body: values,
  });
  if (error) throw error;
  return data;
};

export const deleteCaseTemplateById = async (id: string) => {
  const { error } = await backendClient.delete<void>(`/case-templates/${id}`);
  if (error) throw error;
};

// linking is idempotent on the backend, so a link that already exists is no error
export const linkCaseTemplatePublicPortal = async ({ case_template_id, public_portal_id }: CaseTemplateLink) => {
  const { data, error } = await backendClient.put<CaseTemplateToPublicPortal>(
    `/case-templates/${case_template_id}/public-portals/${public_portal_id}`,
  );
  if (error) throw error;
  return data;
};

export const unlinkCaseTemplatePublicPortal = async ({ case_template_id, public_portal_id }: CaseTemplateLink) => {
  const { error } = await backendClient.delete<null>(
    `/case-templates/${case_template_id}/public-portals/${public_portal_id}`,
  );
  if (error) throw error;
};

export interface ListCaseTemplatesByWorkspaceIdProps {
  workspace_id?: string;
  params?: CaseTemplateListQueryParams;
}
export const getCaseTemplatesByWorkspaceId = async ({ workspace_id, params }: ListCaseTemplatesByWorkspaceIdProps) => {
  const { data, count, error } = await backendClient.get<CaseTemplateExtended[]>(
    `/case-templates/by-workspace/${workspace_id}`,
    {
      params: params,
    },
  );
  if (error) throw error;
  return { data, count };
};
